export default __webpack_public_path__ + "static/media/legend_help.2b551f28.svg";